import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';



// #endregion

export default function SalesLineChart({statsWidget}) {
  return (
    <LineChart
      style={{ width: '100%', height: '100%', maxHeight: '50vh', aspectRatio: 1.618 }}
      responsive
      data={statsWidget}
      margin={{
        top: 5,
        right: 0,
        left: 0,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis width="auto" dataKey="value" />
      <Tooltip />
      <Legend />
    
      <Line type="monotone" dataKey="value"  name='المبيعات' stroke="#FFCC03" strokeWidth={2}  />
    
    </LineChart>
  );
}